<template>
    <div class="col backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <h3 class="col" align="center">Reimpresion de Operaciones de Una Embarcacion </h3>
            <form @submit.prevent="searchReprintShip">
                <div class="btn-group btn-group-toggle col-12 col-md-10" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearchShip">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch" value="enroll" checked> Matriculacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearchShip">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="oper"> Operacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearchShip">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" v-model="optionSearch" value="renew"> Renovacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearchShip">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" v-model="optionSearch" value="penalty"> Sanción
                    </label>
                </div>
                

                <div class="form-row">
                    <div class="form-group col col-md-6 offset-md-2">
                        <label for="data_enrollment" class="badge badge-info">MATRICULA (Exacto):</label>         
                        <input type="text" class="form-control" id="data_enrollment" name="data_enrollment" v-model="data_enrollment" placeholder="CP-1RB-XXXXX" autocomplete="off">
                    </div>
                    <div class="form-group col col-md-2">
                        <label for="quantity_registers" class="badge badge-info">No. REGISTROS:</label>         
                        <input type="number" class="form-control" id="quantity_registers" name="quantity_registers" v-model="quantity_registers" placeholder="1" autocomplete="off">
                    </div>
                </div>
                <button class="btn btn-outline-primary col col-md-4 offset-md-4"><font-awesome-icon icon="list" /> Listar</button>
                
            </form>
        </div>
        <br>
        <transition name="fade">
        <div v-if="debts_local">
            
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th>#</th>
                            <th scoped="col">Operacion</th>
                            <th scoped="col" class="d-none d-md-block">Capitan de Puerto</th>
                            <th scoped="col">Tramite</th>
                            <th scoped="col">Total</th>
                            <th scoped="col">Imprimir</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(debt, index) in debts_local" :key="debt.id_reprint">
                            <td>{{ index+1 }}</td>
                            <td>{{ debt.operation }}</td>
                            <td class="d-none d-md-block">{{ debt.responsability }}</td>
                            <td>{{ debt.correlative }}/{{ debt.anio }}</td>
                            <td>{{ debt.total }}</td>
                            <td align="center">
                                <button class="btn btn-outline-info" @click="mModalShow(debt.id_reprint)"><font-awesome-icon icon="print" /></button>  
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        </transition>
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
    </div>

</template>

<script>
import axios from 'axios';
import Vue from 'vue';
const qs=require('qs');


import modalReport from '../modal/modalReport';

export default {
    name:'discharge',
    data(){
        return{
            optionSearch:'enroll',
            data_enrollment:null,
            quantity_registers:5,
            port_local:[],
            port_select:null,
            debts_local:null,
            dRolUser:false,
            modal_report:'reprintDoc',
            title:'Reimpresion de Documento',
            modal_rep_content:'Reimpresion de Documento',
            url_report:'pdfZarpe',
            id_reporte:0,
            modal_rep_title:'Reporte'
        }
    },
    mounted(){
        // this.getToday(),
        this.chargeInit()
    },
    methods:{
         mViewSearchShip(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;
            setTimeout(()=>{
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
                
                this.optionSearch=radioV;
                this.debts_local=null;
                this.$store.dispatch('sDebtsP/clearDebts', true);
            },200)                
        },
        async searchReprintShip(){
            // enviar la capitania el id con async y await 
            // console.log(this.date_init+ ' ' +this.date_end+' '+this.optionSearch+' '+this.port_select.id);
            // let auxPort;
            // this.debts_local=null;
            console.log('llegando a solicitar el registro')
            if(this.data_enrollment != null && this.quantity_registers > 0 ){
                try {  
                    let dtsSearch={
                        enrollment:this.data_enrollment,
                        option:this.optionSearch,
                        quantity:this.quantity_registers
                    }
                    // console.log(dtsSearch);
                    const debts= await axios.post(`getReprintShip?api_token=${Vue.auth.getToken()}`,qs.stringify(dtsSearch));
                    // console.log(debts);    
                    if(debts.data.length > 0){
                        let auxDeb=debts.data;
                        let n_debts=[];
                        auxDeb.forEach(item => {
                            // console.log(item);
                            // let o= (item.operation === 'M') ? 'MATRICULACION': item.operation;                            
                            let o = '';
                            let type_op='';


                            let aux_operation= item.operation;
                            let aux_oper=aux_operation.includes('CONTRAVENCIONES') ? 'P' : aux_operation;


                            switch(aux_oper){
                                case 'M':
                                    o='MATRICULACION';
                                    this.url_report='pdfRequestEnrollment';
                                break;

                                case 'R':
                                    o='RENOVACION';
                                    this.url_report='pdfRenew';
                                break;


                                case 'P':
                                    o='(CONTRAVENCIONES)';
                                    this.url_report='pdfPenalty';
                                    break;

                                default:
                                    o=aux_oper;
                                    this.url_report='pdfZarpe';
                                break;
                            }
                            // console.log(item.t_dispatch);
                            // console.log(this.url_report)
                            type_op=item.t_dispatch === 'M' ? '(MULTA)': '';
                            o=o+' '+type_op;
                            let auxitem={
                                id_reprint:item.id_download,
                                operation:o,
                                responsability:item.responsability,
                                correlative:item.correlative,
                                anio:item.anio,
                                total:item.total,
                                module:this.optionSearch,
                                port:item.port
                            }
                            n_debts.push(auxitem)
                        });
                        // this.debts_local=debts.data;
                        this.debts_local=n_debts;
                    }else{
                        toastr.info('No se Encontraron Registros', 'Sin Registro');
                    }
                } catch (error) {
                    toastr.info('Error en la Busqueda', 'Sin Registro');
                }
            }else{
                toastr.info('Verifique que los campos esten completos', 'Advertencia')
            }

        },
        async chargeInit(){
            //   llamar al loading hasta esperar que complete todos los datos del formulario hacer lo mismo en la aprobacion de la matricula

            // const ports = await axios.get('getPorts?api_token='+Vue.auth.getToken());        
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.port_local=ports.data;

            this.$store.dispatch('sDebtsP/clearDebts', true);
            this.$store.dispatch('sDocDebts/clearDocument', true);
            this.dRolUser= this.cSessionUser.role !== 4 ? true:false;
        },
        mModalShow(id){
            // aqui configurar todo la url e id que iran
            this.id_reporte=id;
            $('#'+this.modal_report).modal('show');
        },
    },
    computed:{
        total_select(){
            return this.$store.getters['sDebtsP/getDebtsTotal'];
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-report':modalReport
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/finanzas/ReimpresionShip.vue